import NoAccessibleCourseModal from './NoAccessibleCourseModal';

export default NoAccessibleCourseModal;
